(() => {
  const DELAY = 3000;
  const PLACEHOLDER_COPY = 'Designed for style, built for comfort — this piece combines timeless design with premium materials to elevate your everyday wardrobe.';
  const initialized = new WeakSet();

  function removePlaceholderCopy(root = document) {
    root.querySelectorAll('.product-text').forEach((element) => {
      if (element.textContent.trim() === PLACEHOLDER_COPY) {
        element.remove();
      }
    });
  }

  function startAutoplay(gallery) {
    if (!gallery || initialized.has(gallery)) return;

    const swiper = gallery.productImages;
    if (!swiper || swiper.destroyed) return;

    initialized.add(gallery);

    let timer;

    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!document.hidden && gallery.productImages && !gallery.productImages.destroyed) {
          gallery.productImages.slideNext();
        }
        schedule();
      }, DELAY);
    };

    gallery.addEventListener('mouseenter', () => clearTimeout(timer));
    gallery.addEventListener('mouseleave', schedule);

    swiper.on('slideChangeTransitionStart', schedule);
    swiper.on('touchStart', () => {
      clearTimeout(timer);
    });
    swiper.on('touchEnd', schedule);

    schedule();
  }

  function initProductGalleries(root = document) {
    removePlaceholderCopy(root);
    root.querySelectorAll('product-gallery-media').forEach(startAutoplay);
  }

  function init() {
    initProductGalleries();

    document.addEventListener('shopify:section:load', (event) => {
      initProductGalleries(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();